import { render, staticRenderFns } from "./NewCountryModal.vue?vue&type=template&id=1f4accd2&"
import script from "./NewCountryModal.vue?vue&type=script&lang=js&"
export * from "./NewCountryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports